import React from 'react';
import {
  BackWaxCostDivider,
  ForMenHero,
  MenBackAndShoulder,
  MenChestAndStomach,
  MenOtherAreas,
  Men_BA_Divider,
  NeckFaceEar,
  SectionDivider,
  WithoutBackHairDivider,
  SEO,
} from '../../components';
import { graphql } from 'gatsby';

function ForMenPage() {
  return (
    <main id='for-men-page'>
      <ForMenHero />
      <WithoutBackHairDivider />
      <MenBackAndShoulder />
      <Men_BA_Divider />
      <MenChestAndStomach />
      {/* <SectionDivider /> */}
      <NeckFaceEar />
      <BackWaxCostDivider />
      <MenOtherAreas />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Laser Hair Removal for Men | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Say goodbye to hairy situations and hello to smooth, confident skin with our laser hair removal for men. Unleash your inner suave and book your appointment today!'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default ForMenPage;
